import { memo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Popconfirm } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { dateToString, getDownloadUrl } from '@/utils';
import { useDeleteChildDocumentMutation, useGetChildDocumentsQuery } from '@/services/child-api';
import { UploadSvg } from '@/assets/icons';
import Table from '@/components/table';
import Button from '@/components/button';
import UploadModal from './upload-modal';

const Documents = ({ childId, permissions }) => {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const pageNumber = queryParams.get('page') || 1;
  const { data, isFetching, refetch } = useGetChildDocumentsQuery({ childId, pageNumber });
  const [deleteDocument] = useDeleteChildDocumentMutation();

  const [isOpenUploadModal, openUploadModal] = useState(false);

  const columns = [
    {
      title: 'Name',
      dataIndex: 'fileName',
      render: (value, record) => (
        <Button type="link" href={getDownloadUrl(`/blobs/${record.blobId}/download`)}>
          {value}
        </Button>
      ),
    },
    {
      title: 'Type',
      dataIndex: 'childDocumentType',
      render: (value) => value.name,
    },
    {
      title: 'Date',
      dataIndex: 'created',
      render: (value) => dateToString(value, 'M/DD/YYYY h:mm A'),
    },
    permissions.writeChild && {
      title: (
        <Button type="primary" icon={<UploadSvg fontSize="12" />} onClick={() => openUploadModal(true)}>
          Upload
        </Button>
      ),
      key: 'action',
      align: 'right',
      render: (_, record) => (
        <Popconfirm
          title="Are you sure to delete this?"
          icon={<QuestionCircleOutlined style={{ color: '#ff4d4f' }} />}
          okText="Yes"
          cancelText="No"
          onConfirm={async () => {
            try {
              await deleteDocument({ childId, documentId: record.childDocumentId }).unwrap();
              refetch();
            } catch (err) {}
          }}
        >
          <Button type="link" danger>
            Delete
          </Button>
        </Popconfirm>
      ),
    },
  ].filter((item) => item);

  return (
    <>
      <Table
        columns={columns}
        dataSource={data?.data}
        rowKey="childDocumentId"
        loading={isFetching}
        pageInfo={data}
        size="small"
      />

      <UploadModal
        childId={childId}
        open={isOpenUploadModal}
        refetch={refetch}
        onClose={() => openUploadModal(false)}
      />
    </>
  );
};

export default memo(Documents);
